import dayjs from 'dayjs';

import usePlannerStore from '../../store';
import { scrollToDateSmart } from './scroll-to-date';

/**
 * Centers the planner viewport on the filter date range (its middle day).
 *
 * - While a filter-change reload is in flight (pendingScrollRestoreLeft set by
 *   setFilters) or the range lies outside the loaded dates window, navigation
 *   goes through the store's scrollToDate action — the same path as the date
 *   picker / Today button. It re-bootstraps the query range AROUND THE TARGET
 *   and centers after the reload; scrolling pixels directly here would land on
 *   dates whose data was never fetched (the reload was bootstrapped around the
 *   old viewport) and the pending restore would fight the scroll.
 * - Otherwise (bar/arrow click, nothing in flight): scrolls directly —
 *   animated when nearby, instant when far (see scrollToDateSmart).
 */
export const scrollPlannerToFilterRange = (rangeStart: dayjs.Dayjs, rangeEnd: dayjs.Dayjs) => {
  const store = usePlannerStore.getState();
  const { dates } = store;

  const middleDay = rangeStart.add(
    Math.floor(rangeEnd.startOf('day').diff(rangeStart.startOf('day'), 'day') / 2),
    'day'
  );

  const windowStart = dates[0];
  const windowEnd = dates[dates.length - 1];
  const isInsideWindow =
    !!windowStart &&
    !!windowEnd &&
    !middleDay.isBefore(windowStart, 'day') &&
    !middleDay.isAfter(windowEnd, 'day');

  const isFilterReloadInFlight = store.pendingScrollRestoreLeft !== null;

  if (isFilterReloadInFlight || !isInsideWindow) {
    // The navigation action owns the scroll from here — drop the pending
    // filter-change restore so it cannot snap the viewport back afterwards.
    store.setPendingScrollRestoreLeft(null);
    store.scrollToDate(middleDay);
    return;
  }

  scrollToDateSmart(middleDay);
};
